import { render, staticRenderFns } from "./AbaEditarDadosPessoaisUsuario.vue?vue&type=template&id=3db652dc&scoped=true"
import script from "./AbaEditarDadosPessoaisUsuario.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosPessoaisUsuario.vue?vue&type=script&lang=ts"
import style0 from "./AbaEditarDadosPessoaisUsuario.vue?vue&type=style&index=0&id=3db652dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db652dc",
  null
  
)

export default component.exports